import { createContext } from 'react';

export const WinnerContext = createContext();